import {
  Size,
  SizeField,
  SizeFieldInput,
  SizeFieldStock,
  SizeLabel,
  SizePrice,
  SizeTop,
  Sizes,
} from "~/components/ProductQuantitySelector/components";
import LoadingIndicator from "~/components/LoadingIndicator";

type Props = {
  sizes: string[];
};

const EmptyProductQuantitySelector: React.FC<Props> = ({ sizes }) => {
  return (
    <Sizes>
      {sizes.map((size) => (
        <Size key={`quantity-selector-size-${size}`}>
          <SizeTop>
            <SizeLabel>{size}</SizeLabel>
            <SizePrice>
              <LoadingIndicator size="small" />
            </SizePrice>
          </SizeTop>
          <SizeField>
            <SizeFieldInput
              size={size}
              isLoading={true}
            />
            <SizeFieldStock />
          </SizeField>
        </Size>
      ))}
    </Sizes>
  );
};

export default EmptyProductQuantitySelector;
